// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Css from "bs-css-emotion/src/Css.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as I18next$LiveRoom from "../../bindings/I18next.bs.js";
import * as LoadingCard$LiveRoom from "../LoadingCard.bs.js";
import * as CommonStyles$LiveRoom from "../../styles/CommonStyles.bs.js";
import * as SterlingModal$LiveRoom from "../../bindings/SterlingModal.bs.js";
import * as RawHtmlContent$LiveRoom from "../RawHtmlContent.bs.js";
import * as ClientapiQueries$LiveRoom from "../../ClientapiQueries.bs.js";
import * as RefetchModalContent$LiveRoom from "../RefetchModalContent.bs.js";

function ConditionsOfSaleModal(props) {
  var queryResult = Curry.app(ClientapiQueries$LiveRoom.AuctionInfo.AuctionTermsQuery.use, [
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        Curry._2(ClientapiQueries$LiveRoom.AuctionInfo.AuctionTermsQuery.makeVariables, props.auctionId, undefined)
      ]);
  var match = I18next$LiveRoom.useTranslation(undefined);
  var modalTitle = Curry._1(match.t, "Common_conditionsOfBusiness");
  var match$1 = queryResult.data;
  var tmp;
  if (match$1 !== undefined) {
    var refetch = queryResult.refetch;
    var auction = match$1.auction;
    if (auction !== undefined) {
      var stringifyConditionsOfSale = Belt_Option.getWithDefault(JSON.stringify(auction.conditionsOfSale), "");
      var conditionsOfSale = stringifyConditionsOfSale.substring(1, stringifyConditionsOfSale.length - 1 | 0);
      tmp = React.createElement(SterlingModal$LiveRoom.Content.make, {
            children: React.createElement(RawHtmlContent$LiveRoom.make, {
                  html: conditionsOfSale
                }),
            className: Curry._1(Css.style, {
                  hd: Css.marginTop(Css.px(16)),
                  tl: /* [] */0
                })
          });
    } else {
      tmp = React.createElement(RefetchModalContent$LiveRoom.make, {
            refetch: (function (eta) {
                return Curry._3(refetch, undefined, undefined, eta);
              }),
            title: modalTitle
          });
    }
  } else if (queryResult.loading) {
    tmp = React.createElement(SterlingModal$LiveRoom.Content.make, {
          children: React.createElement(LoadingCard$LiveRoom.InfoModal.make, {}),
          className: Curry._1(Css.style, {
                hd: Css.marginTop(Css.px(16)),
                tl: /* [] */0
              })
        });
  } else if (queryResult.error !== undefined) {
    var refetch$1 = queryResult.refetch;
    tmp = React.createElement(RefetchModalContent$LiveRoom.make, {
          refetch: (function (eta) {
              return Curry._3(refetch$1, undefined, undefined, eta);
            }),
          title: modalTitle
        });
  } else {
    var refetch$2 = queryResult.refetch;
    tmp = React.createElement(RefetchModalContent$LiveRoom.make, {
          refetch: (function (eta) {
              return Curry._3(refetch$2, undefined, undefined, eta);
            }),
          title: modalTitle
        });
  }
  return React.createElement(SterlingModal$LiveRoom.Modal.make, {
              children: tmp,
              className: Curry._1(Css.style, {
                    hd: Css.width(Css.pct(100)),
                    tl: {
                      hd: Css.height(Css.pct(100)),
                      tl: {
                        hd: CommonStyles$LiveRoom.mediaV2(/* TabletPortraitAndMobile */2, {
                              hd: Css.important(Css.maxHeight(Css.pct(100))),
                              tl: {
                                hd: Css.important(Css.maxWidth(Css.pct(100))),
                                tl: /* [] */0
                              }
                            }),
                        tl: /* [] */0
                      }
                    }
                  }),
              onClose: props.onClose,
              isOpen: true,
              fixHeader: true,
              headerTitle: modalTitle
            });
}

var AuctionOverviewQuery = ClientapiQueries$LiveRoom.AuctionInfo.AuctionOverviewQuery;

var AuctionTermsQuery = ClientapiQueries$LiveRoom.AuctionInfo.AuctionTermsQuery;

var make = ConditionsOfSaleModal;

export {
  AuctionOverviewQuery ,
  AuctionTermsQuery ,
  make ,
}
/* Css Not a pure module */
